export default{
  props:{
    propertyMin:{
      type:Object,
      required:true
    },
    propertyMax:{
      type:Object,
      required:true
    },
    options:{
      type:Object,
      default:()=>{return {}}
    },
    valueMin:[String,Number],
    valueMax:[String,Number]
  },
  computed:{
    label(){
      const pMin = this.propertyMin;
      const pMax = this.propertyMax;
      return (pMin.unit?pMin.title+", "+pMin.unit:pMin.title) +" - "+(pMax.unit?pMax.title+", "+pMax.unit:pMax.title);
    },
    placeholder(){
      return this.options.placeholder||this.label;
    },
    getValue(){
      return [this.valueMin,this.valueMax];
    },
  },
  methods:{
    setValue(newMinMaxValue){
      this.$emit('input',newMinMaxValue)
    }
  }
}
